var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 29.75V26.9167C22.6666 25.4138 22.0696 23.9724 21.0069 22.9097C19.9442 21.847 18.5028 21.25 16.9999 21.25H8.49992C6.99703 21.25 5.55569 21.847 4.49298 22.9097C3.43027 23.9724 2.83325 25.4138 2.83325 26.9167V29.75M22.6666 4.43133C23.8817 4.74636 24.9579 5.45596 25.7261 6.44876C26.4944 7.44155 26.9112 8.66134 26.9112 9.91667C26.9112 11.172 26.4944 12.3918 25.7261 13.3846C24.9579 14.3774 23.8817 15.087 22.6666 15.402M31.1666 29.75V26.9167C31.1657 25.6611 30.7478 24.4414 29.9785 23.4491C29.2093 22.4568 28.1323 21.7481 26.9166 21.4342M18.4166 9.91667C18.4166 13.0463 15.8795 15.5833 12.7499 15.5833C9.62031 15.5833 7.08325 13.0463 7.08325 9.91667C7.08325 6.78705 9.62031 4.25 12.7499 4.25C15.8795 4.25 18.4166 6.78705 18.4166 9.91667Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.35715dd8e3c34a22bd81ed6f0a24319f.svg";
export { ForwardRef as ReactComponent };